import { render, staticRenderFns } from "./AxisBadge.vue?vue&type=template&id=2d4a2064&scoped=true"
import script from "./AxisBadge.vue?vue&type=script&lang=js"
export * from "./AxisBadge.vue?vue&type=script&lang=js"
import style0 from "./AxisBadge.vue?vue&type=style&index=0&id=2d4a2064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4a2064",
  null
  
)

export default component.exports